import { render } from "./MapSuggestions.vue?vue&type=template&id=a86ecc4c"
import script from "./MapSuggestions.vue?vue&type=script&lang=js"
export * from "./MapSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__